import React, { useEffect, useState } from 'react'
import { SelectChangeEvent, Typography } from '@mui/material'
import {
  ColorSelectorV2,
  SwitchV2,
  SwitchVarient,
} from '@labrav/react-components'
import { useFormikContext } from 'formik'
import clsx from 'clsx'
import {
  extractColorV2,
  hexadecimalColor,
} from '../../../../../../common/utils/productCreationUtil'
import { convertRGBAAlpha } from '../../../../../../common/utils/convertRGBAAlpha'
import { calculateMinMaxResult } from '../../../../../AddEditProductFormComponents/FlyOutProductBranding/FlyOutProductBranding'
import { useStyles as commonStyles } from '../../../../FlyOutStorefront.styles'
import { isBoolean } from 'lodash'
import { useStyles } from './Badges.styles'
import { hexToRgb, rgbToHex } from '../../../../../../utils/colorsConvertor'
import { ListingCardInCreation } from '../../../../../../modules/storefront/listingCardCreation/reducer'

export const BadgesForm: React.FC = () => {
  const { classes } = useStyles()
  const { classes: commonClasses } = commonStyles()
  const { values, errors, touched, setFieldValue, handleBlur } =
    useFormikContext<ListingCardInCreation>()
  const { listingCardData } = values

  const [badgesColorType, setBadgesColorType] = useState<string>(
    listingCardData?.template?.data?.card?.badgesCustomization?.backgroundColor
      ? listingCardData?.template?.data?.card?.badgesCustomization?.backgroundColor?.includes(
          '#'
        )
        ? 'HEX'
        : 'RGB'
      : 'HEX'
  )

  const [badgesColor, setBadgesColor] = useState<string[]>(() => {
    const colorString =
      listingCardData?.template?.data?.card?.badgesCustomization
        ?.backgroundColor || ''
    return extractColorV2(badgesColorType, colorString)
  })

  useEffect(() => {
    const colorString =
      listingCardData?.template?.data?.card?.badgesCustomization
        ?.backgroundColor || ''
    setBadgesColor(extractColorV2(badgesColorType, colorString))
  }, [
    listingCardData?.template?.data?.card?.badgesCustomization?.backgroundColor,
  ])

  const [badgesTextColorType, setBadgesTextColorType] = useState<string>(
    listingCardData?.template?.data?.card?.badgesCustomization?.color
      ? listingCardData?.template?.data?.card?.badgesCustomization?.color?.includes(
          '#'
        )
        ? 'HEX'
        : 'RGB'
      : 'HEX'
  )

  const [badgesTextColor, setBadgesTextColor] = useState<string[]>(() => {
    const colorString =
      listingCardData?.template?.data?.card?.badgesCustomization?.color || ''
    return extractColorV2(badgesTextColorType, colorString)
  })

  useEffect(() => {
    const colorString =
      listingCardData?.template?.data?.card?.badgesCustomization?.color || ''
    setBadgesTextColor(extractColorV2(badgesTextColorType, colorString))
  }, [listingCardData?.template?.data?.card?.badgesCustomization?.color])

  const handleTypeChange = async (event: SelectChangeEvent, type: string) => {
    const typeValue = event.target.value as string
    switch (type) {
      case 'BADGES_BG_COLOR': {
        const resetValue =
          typeValue === 'RGB'
            ? hexToRgb(badgesColor[4]).toString()
            : rgbToHex(
                parseInt(badgesColor[0]),
                parseInt(badgesColor[1]),
                parseInt(badgesColor[2])
              )
        await setBadgesColorType(event.target.value as string)
        await setFieldValue(
          'listingCardData.template.data.card.badgesCustomization.backgroundColor',
          resetValue
        )
        break
      }
      case 'BADGES_TEXT_COLOR': {
        const resetValue =
          typeValue === 'RGB'
            ? hexToRgb(badgesTextColor[4]).toString()
            : rgbToHex(
                parseInt(badgesTextColor[0]),
                parseInt(badgesTextColor[1]),
                parseInt(badgesTextColor[2])
              )
        await setBadgesTextColorType(event.target.value as string)
        await setFieldValue(
          'listingCardData.template.data.card.badgesCustomization.color',
          resetValue
        )
        break
      }
      default:
        break
    }
  }

  const handleColorChange = async (
    index: number,
    event: SelectChangeEvent,
    type: string
  ) => {
    switch (type) {
      case 'BADGES_BG_COLOR': {
        const updatedColorValues = calculateMinMaxResult(
          index,
          [...badgesColor],
          event.target.value as string
        )

        if (badgesColorType === 'RGB') {
          const color = `rgba(${updatedColorValues[0]}, ${updatedColorValues[1]}, ${updatedColorValues[2]}, ${updatedColorValues[3]})`
          await setFieldValue(
            'listingCardData.template.data.card.badgesCustomization.backgroundColor',
            color
          )
        } else {
          const color = hexadecimalColor(
            `${updatedColorValues[4]}`,
            Number(updatedColorValues[3])
          )
          await setFieldValue(
            'listingCardData.template.data.card.badgesCustomization.backgroundColor',
            color
          )
        }
        return
      }
      case 'BADGES_TEXT_COLOR': {
        const updatedColorValues = calculateMinMaxResult(
          index,
          [...badgesTextColor],
          event.target.value as string
        )

        if (badgesTextColorType === 'RGB') {
          const color = `rgba(${updatedColorValues[0]}, ${updatedColorValues[1]}, ${updatedColorValues[2]}, ${updatedColorValues[3]})`
          await setFieldValue(
            'listingCardData.template.data.card.badgesCustomization.color',
            color
          )
        } else {
          const color = hexadecimalColor(
            `${updatedColorValues[4]}`,
            Number(updatedColorValues[3])
          )
          await setFieldValue(
            'listingCardData.template.data.card.badgesCustomization.color',
            color
          )
        }
        return
      }
      default:
        break
    }
  }

  const isReviewsShow = isBoolean(
    values?.listingCardData?.template?.data?.card?.badgesCustomization
      ?.showReviews
  )
    ? values?.listingCardData?.template?.data?.card?.badgesCustomization
        ?.showReviews
    : false
  const handleChangeReviewShow = (e: {
    target: {
      checked: boolean
    }
  }) => {
    setFieldValue(
      'listingCardData.template.data.card.badgesCustomization.showReviews',
      e?.target?.checked
    )
  }

  const isInsightsShow = isBoolean(
    values?.listingCardData?.template?.data?.card?.badgesCustomization
      ?.showInsights
  )
    ? values?.listingCardData?.template?.data?.card?.badgesCustomization
        ?.showInsights
    : false
  const handleChangesInsightsShow = (e: {
    target: {
      checked: boolean
    }
  }) => {
    setFieldValue(
      'listingCardData.template.data.card.badgesCustomization.showInsights',
      e?.target?.checked
    )
  }

  return (
    <div
      className={clsx(
        classes.sectionWrapper,
        classes.sectionHeaderWrapper,
        classes.root,
        classes.content
      )}
      data-testid="badges-component"
    >
      <div className={classes.textContentWrapper}>
        <Typography
          className={commonClasses.textHeading}
          data-testid="badges-text"
        >
          Badges settings
        </Typography>
      </div>
      <div
        className={classes.sectionInnerWrapper}
        data-testid="badges-inner-component"
      >
        <div className={classes.rowContainer}>
          <Typography
            className={classes.sectionTitle}
            data-testid="badges-font"
          >
            Reviews
          </Typography>
          <SwitchV2
            data-testid="reviews-switch"
            checked={isReviewsShow}
            switchVarient={SwitchVarient.DARK}
            onChange={handleChangeReviewShow}
          />
        </div>

        <div className={classes.rowContainer}>
          <Typography
            className={classes.sectionTitle}
            data-testid="badges-font"
          >
            Vendor insights
          </Typography>
          <SwitchV2
            data-testid="insights-switch"
            checked={isInsightsShow}
            switchVarient={SwitchVarient.DARK}
            onChange={handleChangesInsightsShow}
          />
        </div>
        <div className={classes.rowContainer}>
          <Typography className={classes.sectionTitle}>
            Badge background color
          </Typography>
          <div className={classes.colorSelectorWidth}>
            <ColorSelectorV2
              data-testid="color-selector-bg"
              selectedField={badgesColorType}
              placeholder={'#FFFFFF'}
              onBlur={handleBlur}
              keyName={
                'listingCardData.template.data.card.badgesCustomization.backgroundColor'
              }
              colorValues={badgesColor}
              color={convertRGBAAlpha(
                listingCardData?.template?.data?.card?.badgesCustomization
                  ?.backgroundColor || '',
                false
              )}
              onChange={event => handleTypeChange(event, 'BADGES_BG_COLOR')}
              handleColorChange={(index, event) =>
                handleColorChange(index, event, 'BADGES_BG_COLOR')
              }
              isError={
                !!(
                  (touched as any).listingCardData?.template?.data?.card
                    ?.badgesCustomization?.backgroundColor &&
                  (errors as any).listingCardData?.template?.data?.card
                    ?.badgesCustomization?.backgroundColor
                )
              }
              errorText={
                !!(touched as any).listingCardData?.template?.data?.card
                  ?.badgesCustomization?.backgroundColor &&
                ((errors as any).listingCardData?.template?.data?.card
                  ?.badgesCustomization?.backgroundColor ||
                  '')
              }
              secondaryVariant={true}
            />
          </div>
        </div>
        <div className={classes.rowContainer}>
          <Typography className={classes.sectionTitle}>
            Badge text color
          </Typography>
          <div className={classes.colorSelectorWidth}>
            <ColorSelectorV2
              data-testid="color-selector-text"
              selectedField={badgesTextColorType}
              placeholder={'#FFFFFF'}
              onBlur={handleBlur}
              keyName={
                'listingCardData.template.data.card.badgesCustomization.color '
              }
              colorValues={badgesTextColor}
              color={convertRGBAAlpha(
                listingCardData?.template?.data?.card?.badgesCustomization
                  ?.color || '',
                false
              )}
              onChange={event => handleTypeChange(event, 'BADGES_TEXT_COLOR')}
              handleColorChange={(index, event) =>
                handleColorChange(index, event, 'BADGES_TEXT_COLOR')
              }
              isError={
                !!(
                  (touched as any).listingCardData?.template?.data?.card
                    ?.badgesCustomization?.color &&
                  (errors as any).listingCardData?.template?.data?.card
                    ?.badgesCustomization?.color
                )
              }
              errorText={
                !!(touched as any).listingCardData?.template?.data?.card
                  ?.badgesCustomization?.color &&
                ((errors as any).listingCardData?.template?.data?.card
                  ?.badgesCustomization?.color ||
                  '')
              }
              secondaryVariant={true}
            />
          </div>
        </div>
      </div>
    </div>
  )
}
